import { render, staticRenderFns } from "./EditCustomerDialog.vue?vue&type=template&id=825d3582&"
import script from "./EditCustomerDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCustomerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports